import { useQueryClient } from '@tanstack/react-query';

import { DUOS_BASE_KEY } from './getDuos.options';

/**
 * Returns a function that invalidates all duos query cache.
 * Marks queries as stale - they will refetch when next observed.
 */
export const useInvalidateDuos = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: DUOS_BASE_KEY,
    });
};
